import { CustomSelectAndChildren } from '../../../../../../components/CustomSelectAndChildren';
import { MenuItem } from '@mui/material';
import React from 'react';
import WorkShiftsCard from './WorkShiftsCard';
import WorkShiftsSelectApp from '../Funtionality/WorkShiftsSelectApp';
import WorkShifts from '../Modals/WorkShifts';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const WorkShiftsSelect = (
    {
        workShiftsList,
        setWorkShiftsList,
        autoHeight=true
    }
) => {
    const {
        elementRef,
        workShiftAccessTime,
        workShiftSchedule,
        handleWorkShift,
        workShift, setWorkShift,
        emptyFields,
        showModal, setShowModal,
        handleAdded
    } = WorkShiftsSelectApp({
        workShiftsList,
        setWorkShiftsList,
        autoHeight
    });

    return (
        <>

            <div className={'row'}>
                <div className='col-12 px-0'>
                    <CustomSelectAndChildren
                        id={"slt_wss_schedule_access"}
                        name={"workShift"}
                        trans={"schedule_access"}
                        onChange={(e) => {
                            handleWorkShift(e);
                        }}
                        value={workShift?.id || ''}
                        isValidText={"select_a_work_shift_with_assigned_zones"}
                        showNoSelectionOption={false}
                        required={true}
                        emptyFields={emptyFields}
                    >
                        {workShiftSchedule && workShiftSchedule.filter((item) => !workShiftsList?.some((selected) => selected?.id === item?.id)).map((item) => (
                            <MenuItem key={item?.id} value={item?.id}>
                                {item?.name}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
            </div>

            <div className={`${autoHeight ? 'panelTables-container' : ''} custom-scrollbar`} ref={elementRef}>
                <WorkShiftsCard
                    workShiftAccessTime={workShiftAccessTime}
                    workShift={workShift}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    onClickAdded={() => {
                        handleAdded();
                    }}
                    setWorkShift={setWorkShift}
                />
            </div>

            {showModal &&
                <WorkShifts
                    show={showModal}
                    onHide={() => {
                        setShowModal(false);
                    }}
                    workShift={workShift}
                />
            }
        </>
    );

}

export default WorkShiftsSelect
